import React, { useRef } from "react";
import { Box, InputBase, Theme } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

interface SearchBoxProps {
  theme: Theme;
  value: string;
  onChange: (value: string) => void;
  placeHolder?: string;
}

const SearchBox: React.FC<SearchBoxProps> = ({
  theme,
  value,
  onChange,
  placeHolder,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFocus = () => {
    inputRef.current?.focus();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.surface.main,
        width: {
          xs: "100%",
          sm: "100%",
        },
      }}
      className="flex rounded-lg max-w-full items-center justify-between h-14 py-3 px-4"
      onClick={handleFocus}
    >
      <InputBase
        placeholder={placeHolder}
        inputProps={{ "aria-label": "search" }}
        onChange={handleChange}
        value={value}
        inputRef={inputRef}
      />
      <SearchIcon
        className="text-icon-primary"
        onClick={handleFocus}
        style={{ cursor: "pointer" }}
      />
    </Box>
  );
};

export default SearchBox;
